export class EntCompanyWarehousesFilter {
  page: number = 1;
  size: number = 30;
  deleted: boolean = false;
  companyId: number | null | undefined = null;
  warehouseName: string | null = null;
}